import { BASE_PATH as MOVEIQ_BASE_PATH } from '../../steps/moveiq/constants';
import { BASE_PATH as HOMESERVICES_BASE_PATH } from '../../steps/home-services-app/constants';
import { BASE_PATH as PROMOTION_BASE_PATH } from '../../steps/promotions/app/constants';
import { BASE_PATH as INSURANCE_BASE_PATH } from '../../steps/insurance/constants';
import { UTILITIES_MARKET_BASE_PATH } from '../../steps/utilities/utilities-market/constants';

export const MicroAppRegex = new RegExp(
  `(${MOVEIQ_BASE_PATH}|${HOMESERVICES_BASE_PATH}|${PROMOTION_BASE_PATH}|${INSURANCE_BASE_PATH}|${UTILITIES_MARKET_BASE_PATH})`
);
export function isNavigatingWithinMicroAppRoutes(oldUrl, newUrl) {
  const oldBasePath = oldUrl.match(MicroAppRegex);
  const newBasePath = newUrl.match(MicroAppRegex);
  const navingInMicroApp =
    oldBasePath && newBasePath && oldBasePath[1] === newBasePath[1];
  return navingInMicroApp;
}
